import { validate as uuidValidate } from 'uuid'

export const isUUID = (str: string): boolean => {
  if (typeof str !== 'string') return false
  return uuidValidate(str)
}
